import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.leadership-grid .lg-wrapper');
    const popup = document.querySelector('.leadership-grid .lg-popup');

    if (popup && wrapper) {
        // Initialize Swiper
        const swiper = new Swiper('.leadership-popup-slider', {
            slidesPerView: 1,
            spaceBetween: 30,
            autoHeight: true,
            loop: false,
            navigation: {
                nextEl: '.arrow-next',
                prevEl: '.arrow-prev',
            },
        });

        // Open popup on click
        wrapper.querySelectorAll('.lg-innerwrap[data-href]').forEach((el) => {
            el.addEventListener('click', function() {
                const targetId = this.getAttribute('data-href');
                const targetSlide = popup.querySelector(
                    '.swiper-slide[data-id="' + targetId + '"]',
                );
                const slideIndex = Array.from(
                    popup.querySelectorAll('.swiper-slide'),
                ).indexOf(targetSlide);

                if (slideIndex !== -1) {
                    swiper.slideTo(slideIndex);
                }

                document.body.classList.add('hide-scrollbar');
                popup.classList.add('show');
            });
        });

        // Close popup
        popup
            .querySelectorAll('.popup-close, .lg-popup-overlay')
            .forEach((btn) => {
                btn.addEventListener('click', function() {
                    popup.classList.remove('show');
                    document.body.classList.remove('hide-scrollbar');
                });
            });
    }
});
